import { Api } from 'models/services/api';
import { CreateUserTransactionQuery } from 'models/services/graphql';
import { UpdateOrganizationUserCountDataToFetch } from 'models/entities/organization';

import { CreateGqlDataToFetch } from '../../gql';
import { GqlResult } from './gql-result';

type DataToFetch = {
  user: CreateGqlDataToFetch;
  organization: UpdateOrganizationUserCountDataToFetch;
};

const RequestQuery = `
  mutation CreateUserTransaction($user: CreateUserArgs!, $organization: UpdateOrganizationUserCountArgs!) {
    ${CreateUserTransactionQuery}
  }
`;

type ResponseData = {
  data: {
    createUserTransaction: GqlResult;
  };
};

class CreateTransactionGql {

  readonly api: Api<ResponseData>;
  readonly result?: GqlResult;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.createUserTransaction;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, result });
  }

}

export { CreateTransactionGql };